<div class="row" *ngIf="!to.disabled || isEmptySignatureForRememberOnEdit">
    <div class="col-12">
        <canvas #signaturepad class="signature-pad" height="500"></canvas>
    </div>
    <div class="col-12">
        <input
            (click)="clear()"
            type="button"
            class="btn btn-warning"
            value="Clear"
        />
    </div>
</div>
<div *ngIf="to.disabled && !isEmptySignatureForRememberOnEdit">
    <div class="full-width-image-background margin-bottom-10">
        <img class="view-signature" [src]="getSource(model['' + key])" (load)="fitViewSignatureToScreenScale($any($event.target))" />
    </div>
    <input
        *ngIf="to.isRemembered"
        (click)="clearRememberedImage()"
        type="button"
        class="btn btn-warning"
        value="Clear"
    />
</div>
